// src/auth/useAuth.ts
// Purpose: Tiny hook for consuming AuthContext.

import { useContext } from "react";
import { AuthContext } from "./AuthProvider";

export const useAuth = () => useContext(AuthContext);
